import { CentralLoadingIndicator, GvPrimaryButton } from "../../../components";
/* eslint-disable max-len */
import React, { useEffect } from "react";

// import { UpdateHospitalToolTip } from "../../containers/EditHospitalContainer/EditHospitalContainer.style";
import { CloseIcon } from "../../../components/Icons";
import HospitalCard from "../../../components/HospitalCard/HospitalCard";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
// import PopperIcon from "../../../components/Icons/PopperIcon";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import useChangeLocation from "../../../services/edit-hospital-location/edit-hospital-location-mutation";
import { useModal } from "../../../context/ModalContext";
import { useUpdateLocationStore } from "../../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";
import { useHospitalDetailsListStore } from "../../../hooks/redux-hooks/hospital-details-list-store/hospital-details-list-store";
import { useAllServiceStatusStore, useBookingAppointmentTypeStore } from "../../../hooks";
import { useAllServiceStatus } from "../../../services/all-service-status/all-service-status.service";

const UpdateHospitalModal = () => {
  const { closeModal, openModal } = useModal();
  const { locationSelected } = useUpdateLocationStore();
  const { changeHospitalLocation, loading, error, updatedLocation } = useChangeLocation();
  const { pendingPaymentPetList, isBookingBlocked, pausedWellnessPetList, cancelledWellnessPetList } = useOverdueInvoiceStore();
  const { setIsHospitalListUpdated } = useHospitalDetailsListStore();
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();
  const { setServiceStatusStoreUpdated, isServiceStatusStoreUpdated }=useAllServiceStatusStore();
  const { getAllServicesStatus }=useAllServiceStatus();


  const { } = useUserDetail();

  const handleGoToBookAVisit = () =>{
    userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, { start_from: "update_hospital",
      appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
      overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
      is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
    });
    if (!isBookingBlocked && (pendingPaymentPetList.length > 0)) {
      if (cancelledWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
      } else if (pausedWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
      } else {
        openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
      }
    } else {
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
    }
  };
  const handleCloseIcon = () =>{
    closeModal();
  };

  useEffect(()=>{
    changeHospitalLocation({ locationId: locationSelected[0].idLocation });
  }, []);

  useEffect(()=>{
    if (!isServiceStatusStoreUpdated) {
      getAllServicesStatus();
    }
  }, [isServiceStatusStoreUpdated]);


  useEffect(() => {
    if (updatedLocation) {
      userActivityLogger(MIXPANEL_EVENTS.UPDATE_HOSPITAL_SUCCESS, {});
      // setting hospital detail store updated flag to false
      // to reflect hospital change and initiate store updation
      setIsHospitalListUpdated(false);
      setServiceStatusStoreUpdated(false);
    }
    if (error) {
      openModal(MODALS.UPDATE_HOSPITAL_ERROR);
      userActivityLogger(MIXPANEL_EVENTS.UPDATE_HOSPITAL_FAILURE, { failure_reason: error.graphQLErrors[0]?.message });
    }
  }, [error, updatedLocation]);


  if (loading || !isServiceStatusStoreUpdated) {
    return <CentralLoadingIndicator />;
  };


  return (
    <div className="relative flex flex-col justify-between h-[95%] gap-4 p-2">
      {/* <UpdateHospitalToolTip
        title={<div color="inherit" className="flex items-center gap-2">
          <PopperIcon height={19} width={19} />
          <div><span className="font-semibold">Wohoo!</span> Your Home Hospital has been successfully updated!</div>
        </div>}
        placement="top"
        open={true}
        className="w-full md:w-[31em]"
      >
        <div className="absolute left-[50%] top-[-4rem] 2xl:top-[-0.5rem]"></div>
      </UpdateHospitalToolTip> */}

      <div>
        <div onClick={handleCloseIcon} className="flex justify-end cursor-pointer">
          <CloseIcon width = {20} height = {20} />
        </div>
        <div className="text-xl font-semibold text-center geograph-regular">
          Home Hospital Updated!
        </div>
      </div>

      <div className="h-[80%] overflow-y-auto pe-2">
        {locationSelected && <HospitalCard hospitalDetails={locationSelected[0]} isDisplayedInModal={true} displayedModalType="confirmationModal" />}
      </div>

      <div className="w-full flex flex-col gap-2 items-center">
        <GvPrimaryButton
          onClick={handleGoToBookAVisit}
          isDisabled={isBookingBlocked}
          className="!h-[2.3rem]"
          type="button">
          <div className="normal-case font-semibold text-xs text-center">Book Appointment</div>
        </GvPrimaryButton>
      </div>
    </div>
  );
};

export default UpdateHospitalModal;
